import React from "react";
import LoginComponent from "../component/login/login";

const Login = () => {
  return (
    <div>
      <LoginComponent />
    </div>
  );
};

export default Login;
